import SccListDisplayContainer from './SccListDisplayContainer'

export default SccListDisplayContainer
